export const INBOUND_RECEIVE_ROUTES = [
  "purchase_order",
  "transfer_order",
  "manufacturing_transfer_to_shelf",
  "rma",
  "non_po_purchase",
] as const;

export type InboundReceiveRoute = (typeof INBOUND_RECEIVE_ROUTES)[number];

export function isInboundReceiveRoute(value: unknown): value is InboundReceiveRoute {
  return typeof value === "string" && (INBOUND_RECEIVE_ROUTES as readonly string[]).includes(value);
}

export const INBOUND_RECEIVE_ROUTE_UNKNOWN_VALUE = "";

export const INBOUND_RECEIVE_ROUTE_UNKNOWN_LABEL = "Unknown";

export function inboundReceiveRouteLabel(route: InboundReceiveRoute | null | undefined): string {
  switch (route) {
    case "purchase_order":
      return "Purchase order";
    case "transfer_order":
    case "manufacturing_transfer_to_shelf":
      return "Transfer";
    case "rma":
      return "RMA";
    case "non_po_purchase":
      return "Non-PO purchase";
    default:
      return INBOUND_RECEIVE_ROUTE_UNKNOWN_LABEL;
  }
}

export function inboundReceiveRouteDockHubSelectOptions(): { value: string; label: string }[] {
  return [
    ...INBOUND_RECEIVE_ROUTE_DOCK_PICK_OPTIONS.map((option) => ({
      value: option.value,
      label: option.label,
    })),
    { value: INBOUND_RECEIVE_ROUTE_UNKNOWN_VALUE, label: INBOUND_RECEIVE_ROUTE_UNKNOWN_LABEL },
  ];
}

export const INBOUND_RECEIVE_ROUTE_PICK_OPTIONS: {
  value: InboundReceiveRoute;
  label: string;
  description: string;
}[] = [
  {
    value: "non_po_purchase",
    label: "Non-PO purchase",
    description: "Office supplies and expenses without a purchase order.",
  },
  {
    value: "purchase_order",
    label: "Purchase order",
    description: "Inventory purchase order receive (GPO).",
  },
  {
    value: "rma",
    label: "RMA",
    description: "Customer return merchandise; RMA desk workflow.",
  },
  {
    value: "transfer_order",
    label: "Transfer",
    description: "Inter-site, warehouse, or manufacturing transfer receive.",
  },
];

/** Operator pick list at dock log and receive routing (excludes legacy mfg-only route value). */
export const INBOUND_RECEIVE_ROUTE_DOCK_PICK_OPTIONS = INBOUND_RECEIVE_ROUTE_PICK_OPTIONS;

export function inboundReceiveRouteUsesSpecialDesk(route: InboundReceiveRoute): boolean {
  return route === "rma" || route === "non_po_purchase";
}

export function inboundReceiveRouteRequiresPurchaseOrderLink(route: InboundReceiveRoute): boolean {
  return route === "purchase_order";
}

export function inboundReceiveRouteRequiresTransferLink(route: InboundReceiveRoute): boolean {
  return route === "transfer_order" || route === "manufacturing_transfer_to_shelf";
}

export function inboundReceiveRouteRequiresRmaLink(route: InboundReceiveRoute): boolean {
  return route === "rma";
}

/** Collapse legacy mfg-only route values to the single Transfer picker option. */
export function inboundReceiveRouteForDockPicker(
  route: InboundReceiveRoute | null | undefined,
): InboundReceiveRoute | null {
  if (route == null) {
    return null;
  }
  if (route === "manufacturing_transfer_to_shelf") {
    return "transfer_order";
  }
  return route;
}
